import type React from "react";
import type { ReactNode } from "react";
import { Form } from "react-bootstrap";
import type { FieldRenderProps } from "react-final-form";
import type { FormInputProps } from "./FormInput";
import { FormInput } from "./FormInput";

export interface FormTextAreaProps extends FormInputProps {
	/**
	 * Number of rows for the text area.
	 */
	rows?: number;
}

export class FormTextArea extends FormInput<string, FormTextAreaProps> {
	protected renderInput(fieldProps: FieldRenderProps<string>, additionalClass?: string): ReactNode {
		const { disabled, required, placeholder, size, readOnly, tabIndex, autoComplete, type, id, rows, label } =
			this.props;
		const {
			input: { name, value },
			meta: { invalid, touched },
		} = fieldProps;

		return (
			<Form.Control
				className={additionalClass}
				as="textarea"
				aria-label={!label && placeholder}
				size={size}
				readOnly={readOnly}
				disabled={disabled}
				tabIndex={tabIndex}
				autoComplete={autoComplete}
				value={value}
				type={type}
				id={id && this.id}
				placeholder={placeholder}
				required={required}
				// isValid={!disabled && touched && valid}
				isInvalid={!disabled && touched && invalid}
				rows={rows}
				name={name}
				onChange={(event) => {
					this.handleChange(event.currentTarget.value, fieldProps);
				}}
				onFocus={(event: React.FocusEvent<HTMLElement>) => {
					this.handleFocus(event, fieldProps);
				}}
				onBlur={(event: React.FocusEvent<HTMLElement>) => {
					this.handleBlur(event, fieldProps);
				}}
			/>
		);
	}
}
